import script from "./NewAddedWordBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAddedWordBlock.vue?vue&type=script&setup=true&lang=js"

import "./NewAddedWordBlock.vue?vue&type=style&index=0&id=abea5d4a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abea5d4a"]])

export default __exports__